import React, { useContext, useEffect, useState } from "react";
import { Button, Col, Icon, message, Modal, Radio, Row } from "antd";
import style from "./index.module.scss";
import OverflowWrapper from "components/OverflowWrapper";
import PaperContext from "../../context";
import { deleteExamPaper, ExamPaperListItem } from "service/exam";
import Spin from "antd/es/spin";
import { RadioChangeEvent } from "antd/lib/radio";
import { errorMessage } from "service/service";

interface FieldTypesProps {
    value: string; //当前选中试卷
    onChange: (value: string) => void; //切换试卷
    examPaperData: ExamPaperListItem[]; //试卷列表
    loading: boolean; //缓冲状态
}

export default function FieldTypes({
    value,
    onChange,
    examPaperData,
    loading
}: FieldTypesProps) {
    const { setTopics, setPaperId, examId, loadExamPaperData, setChecked } =
        useContext(PaperContext);
    const [type, setType] = useState<ExamPaperListItem[]>(examPaperData! || []);

    useEffect(() => {
        if (!examPaperData) return;
        setType(examPaperData);
    }, [examPaperData]);

    //新建试卷
    const add = () => {
        const newType = { paperName: "试卷", paperId: "" };
        setType([...type, newType]);
        setTopics([]);
        setPaperId("");
    };

    const handleChange = (e: RadioChangeEvent) => {
        if (examPaperData?.length !== type.length) {
            return Modal.confirm({
                title: `当前试卷尚未保存，离开后将不会保存，确定放弃离开?`,
                onOk: async () => {
                    const newType = type;
                    newType.pop();
                    setType(newType);
                    onChange(e.target.value);
                }
            });
        }
        onChange(e.target.value);
    };

    const handleDelete = (paperId: string) => {
        //有未保存的试卷，点击切换误触到删除按钮时不执行
        if (examPaperData?.length !== type.length) return;
        Modal.confirm({
            title: `确认删除？`,
            content: `删除后将无法恢复`,
            onOk: async () => {
                try {
                    await deleteExamPaper(examId, paperId);
                    setChecked(0);
                    await (loadExamPaperData && loadExamPaperData());
                    message.success("删除成功!");
                } catch (e) {
                    message.error(errorMessage(e));
                }
            }
        });
    };

    return (
        <Spin spinning={loading}>
            <Row>
                <Col span={24}>
                    <Button
                        onClick={add}
                        className={style.addBtn}
                        disabled={examPaperData?.length !== type.length}>
                        <Icon type="plus-square" />
                        新增试卷
                    </Button>

                    <OverflowWrapper
                        width={780}
                        depth={2}
                        className={style.overflowWrapper}>
                        <Radio.Group
                            value={value}
                            onChange={handleChange}
                            buttonStyle="solid">
                            {type.map((item: ExamPaperListItem) => (
                                <Radio.Button
                                    className={style.tab}
                                    key={item.paperId}
                                    value={item.paperId}>
                                    <span title={item.paperName}>
                                        {item.paperName}
                                    </span>
                                    {item.paperId !== "" && (
                                        <Icon
                                            type="close"
                                            className={style.close}
                                            onClick={() =>
                                                handleDelete(item.paperId)
                                            }
                                        />
                                    )}
                                </Radio.Button>
                            ))}
                        </Radio.Group>
                    </OverflowWrapper>
                </Col>
            </Row>
        </Spin>
    );
}
